import React from "react";
import ProcureTrackLayout from "./ProcureTrackLayout";

const UserDashboard = () => {
  return <ProcureTrackLayout />;
};

export default UserDashboard;